/**
 *
 * @returns - url with substituted parameters
 * @example - /pb/inbox-notification/{width}/{height}/PB.png -> /pb/inbox-notification/24/24/PB.png
 */
function getUrlWithParams(
	url: string,
	params: Record<string, string | number>,
) {
	return url
		?.split('/')
		.map((urlFragment) => {
			if (/^{[a-zA-Z0-9]+}$/.test(urlFragment)) {
				return params[urlFragment.replace(/[{}]/g, '')] ?? urlFragment;
			}
			return urlFragment;
		})
		.join('/');
}

export { getUrlWithParams };
